import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Select all")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Select all on page")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Clear all")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Online (on prem)")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Offline (on prem)")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Cloud")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Incompatible version")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Duplicate license")

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediCheckbox, IncrediItem, IncrediList, IncrediMenu } from 'incredi-ui';
import { inject, ref } from 'vue';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';
import { IKPlatformAuthentication } from '@/modules/platformAuthentication/platformAuthentication.injectionKeys';
import { useMatomo } from '@/services/matomo/matomo.service';
import { useOsService } from '@/services/OsService/OsService';
import { IKAgentsSelected } from '../../agents-table.InjectionKeys';
import { AgentsFilterSelection } from '../../types/agents-table.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentsTableHeaderCheckboxCell',
  props: {
    modelValue: { type: [Boolean, null] }
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:model-value', value: boolean | null): void }), expose: any, slots: any, attrs: any }) {



const matomo = useMatomo();
const platformAuthentication = inject(IKPlatformAuthentication);
// eslint-disable-next-line no-unused-vars


const multiSelectionMenu = ref(false);
const selectedAgents = inject(IKAgentsSelected);
const osService = useOsService();
const handleSelect = (value: 'All On Page' | 'Clear All' | AgentsFilterSelection) => {
  if (value === 'All On Page') {
    emit('update:model-value', true);
  } else if (value === 'Clear All') {
    selectedAgents?.clearSelection();
  } else {
    selectedAgents?.selectByFilter(value);
  }
  matomo?.trackEvent({
    category: 'Smart Select',
    action: value,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IncrediCheckbox), {
      class: "flex items-center",
      design: "primary-black",
      "model-value": __props.modelValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = 
        newValue => {
          emit('update:model-value', newValue);
        }
      )
    }, null, 8, ["model-value"]),
    _createVNode(_unref(IncrediMenu), {
      modelValue: multiSelectionMenu.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((multiSelectionMenu).value = $event)),
      "offset-y": 4,
      direction: "bottom-sticky-left"
    }, {
      content: _withCtx(() => [
        _createVNode(IbxScopedCss, {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (multiSelectionMenu.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IncrediList), { class: "w-[192px] !p-0" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IncrediList), { class: "!shadow-none" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IncrediItem), {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSelect(_unref(AgentsFilterSelection).All)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IncrediItem), {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSelect('All On Page')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IncrediItem), {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (handleSelect('Clear All')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _hoisted_5,
                _createVNode(_unref(IncrediList), { class: "!shadow-none" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IncrediItem), {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (handleSelect(_unref(AgentsFilterSelection).Online)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IncrediItem), {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (handleSelect(_unref(AgentsFilterSelection).Offline)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    (!_unref(osService)?.isMac?.value)
                      ? (_openBlock(), _createBlock(_unref(IncrediItem), {
                          key: 0,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (handleSelect(_unref(AgentsFilterSelection).Cloud)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(IncrediItem), {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (handleSelect(_unref(AgentsFilterSelection).IncompatibleVersion)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    (_unref(platformAuthentication)?.osType.value === _unref(OsType).Windows)
                      ? (_openBlock(), _createBlock(_unref(IncrediItem), {
                          key: 1,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (handleSelect(_unref(AgentsFilterSelection).DuplicateLicense)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("i", {
          class: _normalizeClass(["uil uil-angle-down text-[24px] h-[32px] cursor-pointer hover:bg-Hovers/hover_grey rounded-[2px] transition duration-300", {
          'bg-Hovers/hover_grey': multiSelectionMenu.value,
        }])
        }, null, 2)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})